import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from '../../login/login.service';
import { Router } from '@angular/router';
import { UserMenuItem } from './user-menu-item';
import { ProfilePictureSelectionComponent } from '../profile-picture-selection/profile-picture-selection.component';

@Component({
  selector: 'smp-user-menu',
  templateUrl: './user-menu.component.html'
})
export class UserMenuComponent implements OnInit {
  private menuItems: UserMenuItem[];

  @ViewChild(ProfilePictureSelectionComponent) profilePictureSelection: ProfilePictureSelectionComponent;

  constructor(
    private loginService: LoginService,
    private router: Router) {

    this.menuItems = [
      new UserMenuItem("Zdjęcie profilowe", "editProfilePictureClick"),
      new UserMenuItem("Wyloguj", "logoutClick")
    ];
  }

  ngOnInit() {
  }

  logoutClick() {
    this.loginService.logout().subscribe(() => {
      const redirectUrl = "login";
      this.router.navigate([redirectUrl]);
    });
  }

  editProfilePictureClick() {
    this.profilePictureSelection.editProfilePicture();
  }
}
